<template>
    <FixEmployeePunch></FixEmployeePunch>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const FixEmployeePunch = defineAsyncComponent(() =>
    import("../../components/Hr/FixEmployeePunch/FixEmployeePunch.vue")
);

export default {
    name: "Fix_Employee_Punch", //The name you are in should not equal the name of the component you are importing.
    components: { FixEmployeePunch, AuthLayout },
};
</script>
